import React from 'react';
import { ClipboardList } from 'lucide-react';
import useBlockStyles from '../common/useBlockStyles';

const STYLE_OPTIONS = {
  defaultBackground: 'section',
  defaultHeadingSize: 'medium',
  defaultAlignment: 'left',
  defaultPadding: 'normal',
};

/**
 * Parse **bold** markers in a string.
 * Returns an array of strings and <strong> elements.
 */
const parseBold = (text) => {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
};

/**
 * BulletinBoardRenderer - Renders a bulletin card with line-by-line text.
 * Heading lives inside the card.
 */
const BulletinBoardRenderer = ({ block, theme = {} }) => {
  const { content } = block;
  const styles = useBlockStyles(content, theme, STYLE_OPTIONS);
  const lines = (content.body || '').split('\n');

  return (
    <div
      className={`w-full ${styles.sectionPaddingClass}`}
      style={{ backgroundColor: styles.sectionBackground }}
    >
      <div className="max-w-2xl mx-auto">
        {/* Card — heading + body together */}
        <div
          className="relative rounded-xl border p-5 sm:p-6 overflow-hidden"
          style={{
            backgroundColor: styles.cardBackground,
            borderColor: styles.borderColor,
          }}
        >
          {/* Decorative icon */}
          <ClipboardList
            size={48}
            className="absolute top-4 right-4 pointer-events-none"
            style={{ color: styles.bodyColor, opacity: 0.08 }}
          />

          {/* Heading inside card */}
          {content.heading && (
            <h3
              className={`${styles.headingSizeClass} font-bold mb-4`}
              style={{ color: styles.headingColor, fontFamily: styles.headingFontStyle }}
            >
              {content.heading}
            </h3>
          )}

          {/* Lines */}
          <div className="space-y-1 relative">
            {lines.map((line, i) =>
              line.trim() === '' ? (
                <div key={i} className="h-2" />
              ) : (
                <p
                  key={i}
                  className="text-base sm:text-lg leading-relaxed"
                  style={{ color: styles.bodyColor, fontFamily: styles.bodyFontStyle }}
                >
                  {parseBold(line)}
                </p>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulletinBoardRenderer;
